module.exports = __webpack_public_path__ + "static/media/gu.a4c325e2.svg";